import { useRef } from 'react';
import { Button, BaseControl } from '@wordpress/components';
import { closeSmall } from '@wordpress/icons';

const GalleryPicker = ({ field, value = [], onChange }) => {
    const requestedSize = field.image_size || 'full';
    const mediaFrame = useRef(null);

    const getImageUrl = (media) => {
        if (!media) return null;

        if (media.sizes && media.sizes[requestedSize]) {
            return media.sizes[requestedSize].url;
        }

        if (media.sizes) {
            const match = Object.values(media.sizes).find(
                (size) => `${size.width}x${size.height}` === requestedSize
            );
            if (match) return match.url;
        }

        return media.url;
    };

    const openMediaLibrary = () => {
        if (mediaFrame.current) {
            mediaFrame.current.open();
            return;
        }

        mediaFrame.current = wp.media({
            title: 'Select Images',
            button: { text: 'Use these images' },
            multiple: true,
            library: {
                type: 'image',
            },
        });

        mediaFrame.current.on('select', () => {
            const selection = mediaFrame.current.state().get('selection');
            const selectedImages = selection.map((item) => {
                const media = item.toJSON();
                const url = getImageUrl(media);
                return url ? { id: media.id, url } : null;
            }).filter(Boolean);

            onChange(selectedImages);
        });

        mediaFrame.current.open();
    };

    const handleRemoveImage = (indexToRemove) => {
        const updated = value.filter((_, index) => index !== indexToRemove);
        onChange(updated);
    };

    return (
        <BaseControl label={field.label} __nextHasNoMarginBottom>
            <div className="voxy-component">
                <div className="gallery-selector">
                    <div className="gallery-selector__preview" onClick={openMediaLibrary}>
                        {value.length > 0 ? (
                            value.map((item, index) => (
                                <div key={index} className="gallery-selector__image">
                                    <img src={item.url} alt={`Gallery ${index}`} />
                                    <Button
                                        className="gallery-selector__remove"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleRemoveImage(index);
                                        }}
                                        icon={closeSmall}
                                        label="Remove Image"
                                    />
                                </div>
                            ))
                        ) : (
                            <div className="gallery-selector__placeholder">+</div>
                        )}
                    </div>
                    <Button
                        onClick={openMediaLibrary}
                        className="gallery-selector__change-btn"
                        variant="secondary"
                    >
                        {value.length ? 'Edit Gallery' : 'Create Gallery'}
                    </Button>
                </div>
            </div>
        </BaseControl>
    );
};

export default GalleryPicker;
